import React from "react";
import colorbar from "../src/images/agartalaairportimages/colorbar.jpg";
import forrest from "../src/images/agartalaairportimages/forest.jpg";
import rareplanet from "../src/images/agartalaairportimages/rereplanet.jpg";
import opium from "../src/images/agartalaairportimages/opium.jpg";

import {Helmet} from 'react-helmet-async';

const Hotels = () => {
  return (
    <>
    <Helmet>
      <title>Hotels</title>
      <meta name='description' content="List of Nearby Hotels from Coimbatore International Airport"/>
      <link rel="canonical" href="/hotels"/>
    </Helmet>
      <table className="table table-striped table-hover table-bordered table-sm">
        <thead>
          <tr className="fs-5 fw-bold">
            <th scope="col ">Shops</th>
            <th scope="col">Available Products</th>
          </tr>
        </thead>
        <tbody className="table-group-divider">


          <tr>
            <td>
              <p className="fs-5 fw-bold">Forrest Essential</p>
              <img
                className="img-thumbnail img-responsive"
                src={forrest}
                width="300"
                height="150"
                alt="skylite hotel"
              />
            </td>
            <td>Collection of Best Perfumes<button className='btn btn-primary'>Call Us</button></td>
          </tr>

          <tr>
            <td>
              <p className="fs-5 fw-bold">Opium</p>
              <img
                className="img-thumbnail img-responsive"
                src={opium}
                width="300"
                height="150"
                alt="Fairfield By Marriott"
              />
            </td>
            <td>Collection of Best Perfumes<button className='btn btn-primary'>Call Us</button></td>
          </tr>

          <tr>
            <td>
              <p className="fs-5 fw-bold">Rare Planet</p>
              <img
                className="img-thumbnail img-responsive"
                src={rareplanet}
                width="300"
                height="150"
                alt="The Residency"
              />
            </td>
            <td>Collection of Best Perfumes<button className='btn btn-primary'>Call Us</button></td>
          </tr>


          <tr>
            <td>
              <p className="fs-5 fw-bold">ColorBar</p>
              <img
                className="img-thumbnail img-responsive"
                src={colorbar}
                width="300"
                height="150"
                alt="The Arcadia"
              />
            </td>
            <td>Collection of Best Perfumes<button className='btn btn-primary'>Call Us</button></td>
          </tr>


          
          
        </tbody>
      </table>
    </>
  );
};

export default Hotels;
